import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { Alert, Snackbar } from '@mui/material';

import store from 'app/store';
import { updateSystemErrorMsg } from 'app/state/reducer';
import { getAlertBanners } from 'app/state/service';
import { getFeaturePermissions, refreshToken } from 'features/login/state/service';
import { ALLIANT_BROKER_CODE } from 'common/AppConstant';
import ConfirmDialog from 'common/ComfirmationDialog';
import UserAgreement from 'common/userAgreement';
import Spinner from 'common/components/spinner';
import AlertBanner from 'common/components/alertBanner';
import AppRoute from './app/router/AppRoute';
import { defaultTheme, alliantTheme } from './customThemes';

import './App.css';

export default function App() {
  const dispatch = useDispatch();
  const jwt = useSelector((state) => state.auth.jwt);
  const jwtExp = useSelector((state) => state.auth.jwtExp);
  const systemMsg = useSelector((state) => state.app.systemMsg);
  const bannerMessages = useSelector((state) => state.app.bannerMessages);
  const termsAccepted = useSelector((state) => state.auth.termsAccepted);
  const carrierCode = useSelector((state) => state.auth.carrierCode);
  const brokerCode = useSelector((state) => state.auth.brokerCode);
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const isFetchingQueue = useSelector(
    (state) => state.app.isFetchingQueue,
  );
  const systemMsgSeverity = useSelector(
    (state) => state.app.systemMsgSeverity,
  );

  const onCloseError = () => {
    dispatch(updateSystemErrorMsg(null));
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    if (termsAccepted === false) {
      handleDialogOpen();
    }
    if (termsAccepted === true) {
      handleDialogClose();
    }
  }, [termsAccepted]);

  useEffect(() => {
    if (carrierCode) {
      store.dispatch(getAlertBanners());
      store.dispatch(getFeaturePermissions());
    }
  }, [carrierCode]);

  useEffect(() => {
    const timer = setInterval(
      () => {
        if (jwtExp) {
          const leftTime = (jwtExp * 1000) - Date.now();
          // if left time > 0 then, the token is valid
          // if the token is expired in 5 mins, refresh the token
          if (leftTime > 0 && leftTime < 300000) {
            store.dispatch(refreshToken());
          }
        }
      },
      1000,
    );
    return () => clearInterval(timer);
  });

  return (
    <ThemeProvider theme={brokerCode === ALLIANT_BROKER_CODE ? alliantTheme : defaultTheme}>
      {systemMsg && (
        <Snackbar
          open
          onClose={onCloseError}
          severity="error"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          autoHideDuration={15000}
        >
          <Alert severity={systemMsgSeverity} onClose={onCloseError}>
            {systemMsg}
          </Alert>
        </Snackbar>
      )}
      {bannerMessages.map((msg) => (<AlertBanner {...msg} />))}
      <AppRoute />
      {isFetchingQueue > 0 && (
        <Spinner />
      )}
      <ConfirmDialog />
      {jwt && (
        <UserAgreement
          open={dialogOpen}
          onClose={handleDialogClose}
        />
      )}
    </ThemeProvider>

  );
}

export { defaultTheme as uiTheme };
